/* eslint-disable react/jsx-no-useless-fragment */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable import/no-extraneous-dependencies */
import { useState, useEffect } from "react";
import {
  Card,
  CardBody,
  Flex,
  Heading,
  Button,
  FormControl,
  FormLabel,
} from "@chakra-ui/react";
import { useNavigate } from "react-router-dom";
import { Controller, useForm } from "react-hook-form";
import { ExcelRenderer } from "react-excel-renderer";
import { Grid, GridColumn } from "@progress/kendo-react-grid";
import BreadCrumb from "../../components/breadCrumb";
import { Paths } from "../../routes/paths";
import ReactHookFormDropdown from "../../components/forms/react-hook-dropdown";
import {
  useLookupCashCenters,
  useLookupCustomers,
} from "../../services/lookups-mutations";
import { useAddStockBulk } from "../../services/stock";
import sweetAlert from "../../components/sweet-alert";
import Loader from "../../components/PageLoader";

export default function AddStockBulk() {
  const [stock, setStock] = useState([]);
  const navigate = useNavigate();
  const {
    mutate: getCustomers,
    data: customerListRes,
    isPending: gettingCustomerList,
    // error: customerListError,
  } = useLookupCustomers();
  const {
    mutate: getCashCenter,
    data: cashCenterList,
    isPending: gettingCashCenterList,
  } = useLookupCashCenters();
  const {
    mutate: addStock,
    data: addStockRes,
    isPending: addingStock,
    reset: resetAddStock,
  } = useAddStockBulk();

  useEffect(() => {
    getCashCenter();
  }, []);
  useEffect(() => {
    getCustomers();
    if (addStockRes) {
      resetAddStock();
      navigate(Paths.stock);
    }
  }, [addStockRes]);
  const {
    handleSubmit,
    control,
    formState: { errors },
  } = useForm({
    defaultValues: { customerId: "", cashCenterId: "", file: "" },
  });

  const generalFieldProps = { errors, control };
  const onSave = (data) => {
    const payload = {
      cashCenterId: data.cashCenterId?.cashCenterId || "",
      customerId: data.customerId?.customerId || "",
      stock: [],
    };
    let isDataValid = true;
    for (let i = 0; i < stock.length; i++) {
      const item = stock[i];
      if (
        !item.Description ||
        !item.Denomination ||
        !item.Maker ||
        !item.Limit ||
        !item.CassetteType ||
        !item.TopSerialNo
      ) {
        sweetAlert({
          title: "Invalid Data",
          text: "Required Fields Are Missing In List",
          icon: "error",
        });
        isDataValid = false;
        break;
      }
      if (!isDataValid) {
        return;
      }
      payload.stock.push({
        description: item.Description || "",
        denomination: item.Denomination || "",
        cassetteType: item.CassetteType || "",
        maker: item.Maker || "",
        limit: Number(item.Limit) || 0,
        topSerialNo: item.TopSerialNo || "",
        bottomSerialNo: item.BottomSerialNo || "",
        status: item.Status || "",
      });
    }

    sweetAlert({
      title: "Operation Confirmation",
      text: `Are you sure you want to add stock`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Confirm",
      cancelButtonText: "Cancel",
      onConfirm: () => {
        addStock(payload);
      },
    });
  };
  const fileHandler = (event, field) => {
    if (event?.target?.files) {
      const fileObj = event.target.files[0];
      ExcelRenderer(fileObj, (err, resp) => {
        if (err) {
          sweetAlert({ title: "Operation Failure", text: err, icon: "error" });
        } else {
          const rows = resp.rows;
          const stock = [];
          const keys = rows.shift(); //keys,header

          rows.forEach((elm) => {
            if (elm && elm.length) {
              const _stock = {};
              elm.forEach((item, index) => {
                _stock[keys[index]] = item;
              });
              keys.forEach((key) => {
                if (_stock[key] === undefined) {
                  _stock[key] = "";
                }
              });

              stock.push(_stock);
            }
          });
          setStock(stock);
          field.onChange(stock);
        }
      });
    } else {
      sweetAlert({
        title: "File Upload Failed",
        text: "Can Not Upload File",
        icon: "error",
      });
    }
  };

  return (
    <>
      {gettingCashCenterList || addingStock || gettingCustomerList ? (
        <Loader />
      ) : (
        <></>
      )}

      <div className="form-container">
        <BreadCrumb
          links={[
            { text: "Stocks", link: Paths.stock },
            { text: "Add Stock", isCurrentPage: true },
          ]}
        />
        <Flex w="100%">
          <Card flexDirection="column" w="100%">
            <CardBody>
              <Heading>Add Stock Bulk</Heading>
              <form
                onSubmit={handleSubmit(onSave)}
                className="add-location-form"
              >
                <ReactHookFormDropdown
                  {...generalFieldProps}
                  isRequired
                  label="Cash Center"
                  name="cashCenterId"
                  id="cashCenterId"
                  text="name"
                  data={cashCenterList?.data || []}
                  placeholder="Select Cash Center"
                  rules={{ required: "Please select cash center" }}
                />
                <ReactHookFormDropdown
                  {...generalFieldProps}
                  isRequired
                  label="Customer"
                  name="customerId"
                  id="customerId"
                  text="name"
                  data={customerListRes?.data || []}
                  placeholder="Select Customer"
                  rules={{ required: "Please select customer" }}
                />
                <div style={{ width: "100%" }} />
                <FormControl isRequired>
                  <FormLabel>File</FormLabel>
                  <Controller
                    control={control}
                    name="file"
                    rules={{ required: "Please upload file" }}
                    render={({ field }) => (
                      <input
                        style={errors.file ? { borderColor: "red" } : {}}
                        type="file"
                        onChange={(event) => {
                          fileHandler(event, field);
                        }}
                        accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                      />
                    )}
                  />

                  {errors.file ? (
                    <p className="error-message">
                      {errors.file.message || "Please Select Field!"}
                    </p>
                  ) : (
                    <></>
                  )}
                </FormControl>
                <Grid data={stock}>
                  <GridColumn title="Description" field="Description" />
                  <GridColumn title="Denomination" field="Denomination" />
                  <GridColumn title="Cassette Type" field="CassetteType" />
                  <GridColumn title="Maker" field="Maker" />
                  <GridColumn title="Limit" field="Limit" />
                  <GridColumn title="Top Serial No" field="TopSerialNo" />
                  <GridColumn title="Bottom Serial No" field="BottomSerialNo" />
                  <GridColumn title="Status" field="Status" />
                </Grid>
                <div
                  style={{
                    width: "100%",
                    display: "flex",
                    justifyContent: "flex-end",
                    gap: "16px",
                  }}
                >
                  <Button type="submit">Add </Button>
                </div>
              </form>
            </CardBody>
          </Card>
        </Flex>
      </div>
    </>
  );
}
